//import region
import React, { useState, useEffect } from 'react';
//custom components
import { TransactionTable } from '_organisms';

//bootstrap
import {Row,Col,Form} from 'react-bootstrap';
//styles
import { Colors} from '_styles';

// redux
import { useSelector, useDispatch, } from 'react-redux';
import { selectAnalytics, getAnalytics, selectTransactions, getTransactions } from '_redux/slices/prm-club/analytics';
import { selectedReward } from '_redux/slices/prm-club/rewards';
import { BsChevronDown } from "react-icons/bs";
import * as RewardService from '_services/rewards-service';

// icons
import { GoTriangleUp, GoTriangleDown} from "react-icons/go";
import { AiOutlineLine } from "react-icons/ai";
import Datetime from "react-datetime";
import 'react-datetime/css/react-datetime.css';

//end import region

const RewardsList = (props) => {

    const toEuroString = (cents) => {
        let euro = cents / 100;
        let euroString = euro.toLocaleString("en-US", {style:"currency", currency:"EUR"});
        return euroString
    }

    // redux
    const dispatch = useDispatch();    
    const analytics = useSelector(selectAnalytics);
    const reward = useSelector(selectedReward)
    const transactionList = useSelector(selectTransactions)

    // states
    // const [clicked, setClicked] = useState("Succeded");
    const [month, setMonth] = useState(new Date().getMonth());
    const [year, setYear] = useState(new Date().getFullYear());
    const [monthString, setMonthString] = useState('');
    const [dateModal, setDateModal] = useState('');

    function updateAnalyticsAndTransactions() {
        dispatch(getAnalytics({
            date:month+1+'_'+year,
            productId:reward?._id
        }));
        dispatch(getTransactions({
            date:month+1+'_'+year,
            productId:reward?._id
        }));
        updateMonthString(month, setMonthString)
    }


    const updateMonthString = () => {
            switch(month){
                case 0:
                    setMonthString('January - February ' + year)
                    break;
                case 1:
                    setMonthString('February - March ' + year)
                    break;
                case 2:
                    setMonthString('March - April ' + year)
                    break;
                case 3:
                    setMonthString('April - May ' + year)
                    break;
                case 4:
                    setMonthString('May - June ' + year)
                    break;
                case 5:
                    setMonthString('June - July ' + year)
                    break;
                case 6:
                    setMonthString('July - August ' + year)
                    break;
                case 7:
                    setMonthString('August - September ' + year)
                    break;
                case 8:
                    setMonthString('September - October ' + year)
                    break;
                case 9:
                    setMonthString('October - November ' + year)
                    break;
                case 10:
                    setMonthString('November - December ' + year)
                    break;
                case 11:
                    setMonthString('December - January ' + year)
                    break;
            }
        }


    // get analytics

    // month change
    useEffect(() => {
        if(reward) {
            updateAnalyticsAndTransactions()
        }
    }, [reward, month]); 

    const PercentageTile = (props) => {


        return (
            <div>
                <Form.Label className="mt-4" style={{ color:Colors.PRM_LIGHT_BLUE}}>{props.title}</Form.Label>
                <p style={{fontSize:30, fontWeight:'200'}}>{props.date}</p>

                <div style={{display:'flex'}}>
                    <p style={{fontSize:48, fontWeight:'200'}}>{props.number}</p>
                    {
                        props.color == '#30E23E' ?
                            <GoTriangleUp size={26} color={props.color} style={{marginTop:30, marginLeft:12}} />
                        :
                        props.color == 'red' ?
                            <GoTriangleDown size={26} color={props.color} style={{marginTop:30, marginLeft:12}} />
                        :
                            <AiOutlineLine size={26} color={props.color} style={{marginTop:30, marginLeft:12}} />
                    }
                    <p style={{fontSize:28, fontWeight:'100', color:props.color, marginTop:22, marginLeft:12}}>{props.percentage}</p>
                </div>
            </div>
        )
    }
   
    return (
        <>
            {/* Analytics */}
            <Row style={{}}> 

                {/* Title */}
                <p className="mt-5" style={{fontSize:26, fontWeight:'bold'}}>Product analytics</p>

                <div className="mt-3" style={{display:'flex', justifyContent:'space-between'}}>
                    <p style={{fontSize:18, fontWeight:'600', opacity:0.6}}>View how your product is performing on PRM Marketplace</p>
                </div>
                
                <Col xs={3} className='mt-5'>
                    <Row>
                        <Col xs={9}>
                            <p style={{ color:Colors.PRM_LIGHT_BLUE }}>Select Month and Year</p>
                        </Col>
                        <Col>
                            <BsChevronDown onClick={()=>{setDateModal(!dateModal)}} size={20} style={{cursor:'pointer', marginBottom:25, marginLeft:30}} color='#307FE2'/>
                        </Col>
                    </Row>
                    <Datetime dateFormat="MM YYYY" value={new Date(year, month)} timeFormat={false} open={dateModal} onChange={(date) => {
                        if(!(typeof date === 'string')) {
                            setYear(date.year())
                            setMonth(date.month())
                        }
                    }}/>
                </Col>

                <Col className="mt-4" style={{marginLeft:100}}>
                    <PercentageTile
                        title="Sales"
                        date={monthString}
                        number={analytics && analytics.numberSold ? analytics.numberSold : '0'}
                        percentage={(analytics && analytics.salesIncrease)  ? analytics.salesIncrease.toFixed() + '%' : '0%'}
                        color={
                            (analytics && analytics.salesIncrease && analytics.salesIncrease > 0) ? '#30E23E'
                            :
                            (analytics && analytics.salesIncrease && analytics.salesIncrease < 0) ? 'red'
                            :
                            Colors.PRM_LIGHT_BLUE
                        }
                    />
                </Col>
                <Col className="mt-4">
                    <PercentageTile
                        title="Gross Revenue"
                        date={monthString}
                        number={analytics && analytics.numberSold && analytics.totalRevenue && reward ? toEuroString(analytics.totalRevenue) : 0}
                        percentage={(analytics && analytics.revenueIncrease) ? analytics.revenueIncrease.toFixed() + '%' : '0'}
                        color={
                            (analytics && analytics.revenueIncrease && analytics.revenueIncrease > 0) ? '#30E23E'
                            :
                            (analytics && analytics.revenueIncrease && analytics.revenueIncrease < 0) ? 'red'
                            :
                            Colors.PRM_LIGHT_BLUE
                        }
                    />
                </Col>
            </Row>

            {/* Transaction List */}
            <Row className="mt-3">                
                <TransactionTable list={transactionList} />
            </Row>

        </>
    );
}

export default RewardsList;